import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaInfoCircle } from 'react-icons/fa';

const About = () => {
  const { t } = useTranslation('about');

  return (
    <StyledAbout>
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {t('title')}
      </motion.h1>
      
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="description"
      >
        {t('description')}
      </motion.p>

      <div className="contact-info">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="contact-item"
        >
          <FaPhone className="icon" />
          <span>+34 634 21 15 16</span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="contact-item"
        >
          <FaEnvelope className="icon" />
          <span>info@alejandrogl.es</span>
        </motion.div>
      </div>
    </StyledAbout>
  );
};

const StyledAbout = styled.div`
  max-width: 800px;
  margin: 50px auto;
  padding: 20px;
  text-align: center;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  border-radius: 10px;

  h1 {
    font-size: 2.5rem;
    color: #008080;
  }

  .description {
    font-size: 1.2rem;
    margin: 15px 0;
    color: #333;
  }

  .contact-info {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .contact-item {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    color: #444;
  }

  .icon {
    margin-right: 10px;
    color: #008080;
  }
`;

export default About;